"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var chartbase_1 = require("../chartbase");
var compare_props_equal_1 = require("../_chart/lib/compare-props-equal");
function BasicLine(props) {
    var ref = props.chartRef;
    var chartRef = react_1.useRef();
    var _a = tslib_1.__read(react_1.useState(props), 2), newProps = _a[0], updateProps = _a[1];
    var shapeRef = react_1.useRef();
    react_1.useEffect(function () {
        if (chartRef.current) {
            shapeRef.current = chartRef.current.line();
        }
    }, [chartRef]);
    react_1.useImperativeHandle(ref, function () { return ({
        on: function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (chartRef.current) {
                (_a = chartRef.current).on.apply(_a, tslib_1.__spread(args));
            }
        },
        once: function (eventName, callback) {
            if (chartRef.current) {
                chartRef.current.once(eventName, callback);
            }
        },
        off: function (eventName, callback) {
            if (chartRef.current) {
                chartRef.current.off(eventName, callback);
            }
        },
        emit: function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (chartRef.current) {
                (_a = chartRef.current).emit.apply(_a, tslib_1.__spread(args));
            }
        },
        getData: function (x) {
            return shapeRef.current.getData(x);
        },
        getDataFromCategory: function (category) {
            return shapeRef.current.getDataFromCategory(category);
        },
        getPosition: function (category, value) {
            return shapeRef.current.getPosition(category, value);
        },
    }); });
    react_1.useEffect(function () {
        if (!compare_props_equal_1.comparePropsEqual(newProps, props)) {
            updateProps(props);
        }
    }, [newProps, props]);
    react_1.useEffect(function () {
        var position = newProps.position, _a = newProps.size, size = _a === void 0 ? 3 : _a, color = newProps.color, _b = newProps.xAxis, xAxis = _b === void 0 ? true : _b, _c = newProps.yAxis, yAxis = _c === void 0 ? true : _c, connectNulls = newProps.connectNulls, smooth = newProps.smooth, canvasMode = newProps.canvasMode;
        var xAxes = typeof xAxis === "boolean" ? { enable: xAxis } : xAxis;
        var yAxes = typeof yAxis === "boolean" ? { enable: yAxis } : yAxis;
        var connectNull = typeof connectNulls === "boolean"
            ? { enable: connectNulls }
            : connectNulls;
        shapeRef.current
            .position(position)
            .color(color)
            .size(size)
            .axis({ xAxis: xAxes, yAxis: yAxes })
            .connectNulls(connectNull)
            .shape({ smooth: smooth, canvasMode: canvasMode });
    }, [newProps]);
    return react_1.useMemo(function () {
        return react_1.default.createElement(chartbase_1.ChartBase, tslib_1.__assign({}, newProps, { ref: chartRef }));
    }, [newProps]);
}
exports.BasicLine = BasicLine;
//# sourceMappingURL=BasicLine.js.map